function updateCartBubble(i) {
  const t = document.getElementById("CartBubble");
  i ? (t.classList.remove("hidden"), t.innerHTML = i) : (t.classList.add("hidden"), t.innerHTML = "")
}

function getAllCartItemsQuantity(){
  const items = document.querySelectorAll('.cart-modal-item');
  let quantity = 0;
  items.forEach(item=>{
    quantity = quantity + parseInt(item.getAttribute('data-cart-item-quantity'))
  })

  return quantity;
}

window.monster_refresh = function (){
  document.querySelector("cart-modal").reloadContent();
  setTimeout(function(){
    document.querySelector("cart-modal").reloadContent();
    document.querySelector('[target="#cart-modal"] a').click();
    updateCartBubble(getAllCartItemsQuantity());
  }, 1000);
}

function translateText(node) {
    if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = node.textContent
            .replace(/\bTotal\b/g, "Gesamt")
            .replace(/\bBUY\b/g, "Kaufen")
            .replace(/\bGET\b/g, "Erhalte")
            .replace(/\bQty\b/g, "Anzahl")
            .replace(/\bFREE\b/g, "Kostenlos")
            .replace(/\bFree\b/g, "Kostenlos")
            .replace(/\bSubscribed\b/g, "Abonniert")
            .replace(/\bSubscribe and Save More\b/g, "Abonnieren und mehr sparen")
            .replace(/\bDeliver Every\b/g, "Lieferung")
            .replace(/\boff\b/g, "Rabatt");
    } else if (node.nodeType === Node.ELEMENT_NODE) {
        node.childNodes.forEach(translateText);
    }
}
function calculateAndStyleDiscount(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    let textContent = node.textContent;

    // Check if the text content contains the discount markers
    if (textContent.includes('[DISCOUNT %]') ||
      textContent.includes('[DISCOUNT €]')) {

      // Find the _offerWrapperV2 parent
      let offerWrapper = findAncestor(node.parentNode,
        (el) => el.className && el.className.startsWith('_offerWrapperV2'));

      if (offerWrapper) {
        // Extract prices - using more robust selectors
        const pricingContainer = offerWrapper.querySelector(
          '[class^="_offerPricingContainerV2"]'
        );

        if (pricingContainer) {
          const discountedPriceElement = pricingContainer.querySelector(
            'div:first-child span:first-child'
          );
          const originalPriceElement = pricingContainer.querySelector(
            'div[style*="line-through"] span:first-child'
          );

          if (discountedPriceElement && originalPriceElement) {
            const discountedPriceText = discountedPriceElement.textContent;
            const originalPriceText = originalPriceElement.textContent;

            const discountedPrice = parseFloat(
              discountedPriceText.replace(/[^\d.]/g, '')
            );
            const originalPrice = parseFloat(
              originalPriceText.replace(/[^\d.]/g, '')
            );

            if (!isNaN(discountedPrice) && !isNaN(originalPrice)) {
              let discountValue;
              let discountType;

              if (textContent.includes('[DISCOUNT %]')) {
                discountValue = ((originalPrice - discountedPrice) /
                  originalPrice) * 100;
                discountType = '%';
              } else {
                discountValue = originalPrice - discountedPrice;
                discountType = '€';
              }
              
              console.log('Discount:', discountValue.toFixed(2), discountType);
              
              if(discountValue.toFixed(2) > 0){
                node.textContent = node.textContent.replace('[DISCOUNT %]', discountValue.toFixed(0) + '' + discountType)
                node.textContent = node.textContent.replace('[DISCOUNT €]', discountValue.toFixed(2) + '' + discountType)
              }
              

              // Apply style to the original text node's parent (optional)
              node.parentNode.style.backgroundColor = "#ca3311";
              node.parentNode.style.color = "white";
            } else {
              console.warn("Could not parse prices:", discountedPriceText,
                originalPriceText);
            }
          } else {
            console.warn("Could not find price elements in:", pricingContainer);
          }
        } else {
          console.warn("Could not find _offerPricingContainerV2 parent for:",
            offerWrapper);
        }
      } else {
        console.warn("Could not find _offerWrapperV2 parent for:", node);
      }
    }
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    node.childNodes.forEach(calculateAndStyleDiscount);
  }
}

// Helper function to find an ancestor element
function findAncestor(el, test) {
  while ((el = el.parentNode) && !test(el));
  return el;
  }

function processDivs() {
    document.querySelectorAll('div[id^="kefi_"]').forEach(translateText);
    document.querySelectorAll('div[id^="kefi_"]').forEach(calculateAndStyleDiscount);
}

// Observer to detect new elements
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.matches('div[id^="kefi_"]')) {
                    translateText(node);
                }
                node.querySelectorAll('div[id^="kefi_"]').forEach(translateText);
              if (node.matches('div[id^="kefi_"]')) {
                calculateAndStyleDiscount(node);
              }
              node.querySelectorAll('div[id^="kefi_"]').forEach(calculateAndStyleDiscount);
            }
        });
    });
});

// Start observing changes in the body
observer.observe(document.body, { childList: true, subtree: true });

// Translate already loaded elements
const initInterval = setInterval(processDivs, 1000);

setTimeout(function(){
  clearInterval(initInterval)
},5000)